import { useState, useEffect } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  PageContainer, PremiumCard, Button, EmptyState,
} from "components/ui";

const Holidays = () => {
  const axiosPrivate = useAxiosPrivate();
  const [holidays, setHolidays] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axiosPrivate.get("/holiday/all");
        setHolidays(res.data);
      } catch (_) {
        console.error("Failed to fetch holidays");
      }
    })();
  }, []);

  const handleDateChange = (date) => {
    if (!selectedDates.some((d) => d.getTime() === date.getTime())) {
      setSelectedDates([...selectedDates, date]);
    }
  };
  const handleRemoveDate = (date) => {
    setSelectedDates(selectedDates.filter((d) => d.getTime() !== date.getTime()));
  };
  const handleSaveHolidays = () => {
    const payload = selectedDates.map((d) => d.toLocaleDateString("en-CA"));
    axiosPrivate.post("/holiday/save", payload)
      .then(() => alert("Holidays saved successfully!"))
      .catch((err) => { console.error(err); alert("Error saving holidays"); });
  };

  return (
    <PageContainer>
      <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", gap: 16 }}>
        <PremiumCard title="Select holidays" subtitle="Highlighted dates are already saved">
          <DatePicker
            selected={null}
            onChange={handleDateChange}
            inline
            highlightDates={holidays.map((h) => new Date(h))}
          />
        </PremiumCard>

        <PremiumCard
          title="Selected dates"
          actions={
            <Button variant="primary" size="sm" onClick={handleSaveHolidays} disabled={selectedDates.length === 0}>
              Save holidays
            </Button>
          }
        >
          {selectedDates.length === 0 ? (
            <EmptyState title="No dates selected" description="Tap a day on the calendar to add it here." />
          ) : (
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 8 }}>
              {selectedDates.map((d, i) => (
                <li
                  key={i}
                  style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    padding: "10px 14px",
                    background: "var(--surface-muted)",
                    border: "1px solid var(--border-subtle)",
                    borderRadius: 10,
                  }}
                >
                  <span className="t-mono">{d.toLocaleDateString()}</span>
                  <Button variant="ghost" size="sm" onClick={() => handleRemoveDate(d)}>Remove</Button>
                </li>
              ))}
            </ul>
          )}
        </PremiumCard>
      </div>
    </PageContainer>
  );
};

export default Holidays;
